import React, {useState} from 'react';
import {Box, Typography, TextField, Button, Card, CardContent, Link} from '@mui/material';
import Grid2 from "@mui/material/Unstable_Grid2";
import emailjs from "emailjs-com";
const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        compagny: '',
        phoneNumber:'',
        message: '',
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        emailjs.send(
            'service_bd6pp67',   // Remplacez par le SERVICE_ID EmailJS
            'template_42xmkpc',  // Remplacez par le TEMPLATE_ID EmailJS
            formData,
            'e-ybTJj1CPzfHM6VG'       // Remplacez par le USER_ID EmailJS
        )
            .then((result) => {
                console.log('Email envoyé:', result.text);
                alert('Votre message a été envoyé avec succès !');
            })
            .catch((error) => {
                console.log('Erreur lors de l\'envoi de l\'e-mail:', error.text);
                alert('Erreur lors de l\'envoi du message. Veuillez réessayer.');
            });
    };


    return (
        <Box sx={{ padding: '40px', backgroundColor: '#f0f4fa' }}> {/* Overall container with padding and background color */}
            <Grid2 container spacing={4} justifyContent="space-between">
                {/* Left Section */}
                <Grid2 xs={12} md={6}>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1, fontFamily: 'unset', fontSize: {xs: '2rem', md: '2.7rem'} }}>
                        Contactez-nous !
                    </Typography>
                    <Typography sx={{ mb: 2, fontFamily: 'unset', fontSize: {xs: '1.2rem', md: '1.2rem'} }}>
                        Un souci électrique ? Un devis en tête ? Un coup de fil suffit !
                    </Typography>
                    <Typography variant="body1" sx={{ fontFamily: 'unset', fontSize: {xs: '1.1rem', md: '1.2rem'}} }>
                        <Link href="tel:0698281814" underline="always" sx={{ color: 'inherit' }}>
                            06 98 28 18 14
                        </Link>
                        <br />
                        <Link href="mailto:contact@chamrouk-production.fr" underline="always" >
                            contact@chamrouk-production.fr
                        </Link>
                    </Typography>
                    <Grid2 container spacing={2} sx={{ mt: 4 }}>
                        <Grid2 xs={12} md={4}>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: 'unset' }}>
                                Assistance Clientèle
                            </Typography>
                            <Typography variant="body1" sx={{ fontFamily: 'unset', fontSize: {xs: '1.1rem', md: '1.2rem'} }}>
                                Notre équipe est disponible 24h/24 pour répondre à toutes vos préoccupations.
                            </Typography>
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={2} sx={{ mt: 4 }}>
                        <Grid2 xs={12} md={4}>
                            <Typography variant="h5" sx={{fontWeight: 'bold', fontFamily: 'unset'}}>
                                Zone d'intervention
                            </Typography>
                            <Typography variant="body1" sx={{fontFamily: 'unset', fontSize: {xs: '1.1rem', md: '1.2rem'} }}>
                                Orléans, 45000 et ses environs.
                            </Typography>

                            <Box
                                sx={{
                                    width: {
                                        xs: '100%',  // Pleine largeur sur téléphones
                                        sm: '350px', // Largeur moyenne
                                        md: '550px'  // Largeur sur écrans plus grands
                                    },
                                    height: {
                                        xs: '300px', // Hauteur sur téléphones
                                        sm: '400px', // Hauteur moyenne
                                        md: '450px'  // Hauteur sur écrans plus grands
                                    },
                                    overflow: 'hidden',
                                    borderRadius: '8px', // Optionnel, pour arrondir les coins
                                    mt: 4,
                                }}
                            >
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d81178.08693679734!2d1.8243447106583064!3d47.90358788985221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e4e55c94676ebf%3A0xe6b4e79bff289f8d!2sCHAMROUK%20PRODUCTION!5e0!3m2!1sfr!2sfr!4v1730550251071!5m2!1sfr!2sfr"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </Box>
                            {/*<iframe*/}
                            {/*    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2676.093849016366!2d1.9305924!3d47.876510200000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e4e55c94676ebf%3A0xe6b4e79bff289f8d!2sCHAMROUK%20PRODUCTION!5e0!3m2!1sfr!2sfr!4v1730548194376!5m2!1sfr!2sfr"*/}
                            {/*    width="750" height="450" style={{border:0, marginTop: 30}} allowFullScreen loading="lazy"*/}
                            {/*    referrerPolicy="no-referrer-when-downgrade">*/}
                            {/*</iframe>*/}

                        </Grid2>
                    </Grid2>
                </Grid2>

                {/* Right Section */}
                <Grid2 xs={12} md={5}>
                    <Card sx={{boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', borderRadius: 5}}>
                        <CardContent>
                            <Typography variant="h4" sx={{fontWeight: 'bold', mb: 2, fontFamily: 'unset'}}>
                                Entrer en contact
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 2, fontFamily: 'unset' }}>
                                Compléter le formulaire :
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid2 container spacing={2}>
                                    <Grid2 xs={12} sm={6}>
                                        <TextField fullWidth
                                                   label="Votre nom"
                                                   name="name"
                                                   variant="outlined"
                                                   value={formData.name}
                                                   onChange={handleChange}
                                                   required
                                                   InputProps={{
                                                       sx: {
                                                           borderRadius: 5, // arrondir les coins
                                                           fontFamily: 'inherit'
                                                       },
                                                   }}

                                        />
                                    </Grid2>
                                    <Grid2 xs={12} sm={6}>
                                        <TextField fullWidth
                                                   label=" Votre societé"
                                                   name="compagny"
                                                   onChange={handleChange}
                                                   variant="outlined"
                                                   value={formData.compagny}
                                                   InputProps={{
                                                       sx: {
                                                           borderRadius: 5, // arrondir les coins
                                                           fontFamily: 'inherit'
                                                       },
                                                   }}
                                        />
                                    </Grid2>
                                    <Grid2 xs={12}>
                                        <TextField fullWidth label="Votre email"
                                                   variant="outlined"
                                                   name="email"
                                                   onChange={handleChange}
                                                   type="email"
                                                   value={formData.email}
                                                   required
                                                   InputProps={{
                                                       sx: {
                                                           borderRadius: 5, // arrondir les coins
                                                           fontFamily: 'inherit'
                                                       },
                                                   }}
                                        />
                                    </Grid2>
                                    <Grid2 xs={12}>
                                        <TextField fullWidth
                                                   label="Numéro de téléphone"
                                                   variant="outlined"
                                                   name="phoneNumber"
                                                   onChange={handleChange}
                                                   type="tel"
                                                   value={formData.phoneNumber}
                                                   required
                                                   InputProps={{
                                                       sx: {
                                                           borderRadius: 5, // arrondir les coins
                                                           fontFamily: 'inherit'
                                                       },
                                                   }}
                                        />

                                    </Grid2>
                                    <Grid2 xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Comment pouvons-nous vous aider ?"
                                            variant="outlined"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            multiline
                                            rows={4}
                                            InputProps={{
                                                sx: {
                                                    borderRadius: 5, // arrondir les coins
                                                    fontFamily: 'inherit'
                                                },
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2 xs={12}>
                                        <Button type={"submit"} fullWidth variant="contained" sx={{ backgroundColor: '#3f72b5', color: '#fff', borderRadius: 5, fontFamily: 'unset' }}>
                                            Envoyer
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            </form>
                            {/*<Typography variant="body2" sx={{ mt: 2 }}>*/}
                            {/*    By contacting us, you agree to our{' '}*/}
                            {/*    <span style={{ color: '#2979ff', cursor: 'pointer' }}>Terms of service</span> and{' '}*/}
                            {/*    <span style={{ color: '#2979ff', cursor: 'pointer' }}>Privacy Policy</span>.*/}
                            {/*</Typography>*/}
                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default ContactUs;
